import React, { useState, useEffect, useCallback } from "react";
import "./ImageGallery.css";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import { useLanguage } from "../context/LanguageContext";

// Import all baby product images
import baby1 from "../images/baby_products/20240708_222204.jpg";
import baby2 from "../images/baby_products/20240709_173022.jpg";
import baby3 from "../images/baby_products/20240709_173038.jpg";
import baby4 from "../images/baby_products/20240709_173607.jpg";
import baby5 from "../images/baby_products/20240709_182307.jpg";
import baby6 from "../images/baby_products/20240709_184040.jpg";

// Import all bat mitzvah images
import batMitzva1 from "../images/bat_mitzva/20250227_210620.jpg";
import batMitzva2 from "../images/bat_mitzva/20250227_214035.jpg";
import batMitzva3 from "../images/bat_mitzva/20250227_220520.jpg";

// Hanukka Gelt Images
import chanukah1 from "../images/hanukka_gelt/20181124_191456.jpg";
import chanukah2 from "../images/hanukka_gelt/20181124_191709.jpg";
import chanukah3 from "../images/hanukka_gelt/20191219_182222.jpg";
import chanukah4 from "../images/hanukka_gelt/20191219_182242.jpg";
import chanukah5 from "../images/hanukka_gelt/20191219_182250.jpg";
import chanukah6 from "../images/hanukka_gelt/20201203_171641.jpg";
import chanukah7 from "../images/hanukka_gelt/20201203_171814.jpg";
import chanukah8 from "../images/hanukka_gelt/20201203_172231.jpg";
import chanukah9 from "../images/hanukka_gelt/20211118_175956.jpg";
import chanukah10 from "../images/hanukka_gelt/20221208_171605.jpg";
import chanukah11 from "../images/hanukka_gelt/20221208_175416.jpg";
import chanukah12 from "../images/hanukka_gelt/20221208_175417.jpg";
import chanukah13 from "../images/hanukka_gelt/20241223_190057.jpg";
import chanukah14 from "../images/hanukka_gelt/20241223_190120.jpg";
import chanukah15 from "../images/hanukka_gelt/20241223_190716.jpg";

// Import all school supplies images
import school1 from "../images/school_supplies/20240819_172719.jpg";
import school2 from "../images/school_supplies/20240819_172720.jpg";
import school3 from "../images/school_supplies/20240819_172728.jpg";
import school4 from "../images/school_supplies/20240819_172731.jpg";
import school5 from "../images/school_supplies/20240819_180536.jpg";
import school6 from "../images/school_supplies/20240819_181507.jpg";

// Import all Tu Bishvat images
import tuBishvat1 from "../images/tu_bishvat/20250208_182352(0).jpg";
import tuBishvat2 from "../images/tu_bishvat/20250208_210917.jpg";
import tuBishvat3 from "../images/tu_bishvat/20250208_215251.jpg";

// Import cleaning supplies images
import cleaning1 from "../images/cleaning_supplies/WhatsApp Image 2025-04-02 at 22.30.45.jpeg";
import cleaning2 from "../images/cleaning_supplies/WhatsApp Image 2025-04-03 at 00.06.14 (1).jpeg";
import cleaning3 from "../images/cleaning_supplies/WhatsApp Image 2025-04-03 at 00.06.14.jpeg";
import cleaning4 from "../images/cleaning_supplies/WhatsApp Image 2025-04-03 at 00.06.15 (1).jpeg";
import cleaning5 from "../images/cleaning_supplies/WhatsApp Image 2025-04-03 at 00.06.15 (2).jpeg";
import cleaning6 from "../images/cleaning_supplies/WhatsApp Image 2025-04-03 at 00.06.15.jpeg";
import cleaning7 from "../images/cleaning_supplies/WhatsApp Image 2025-04-03 at 00.06.16 (1).jpeg";
import cleaning8 from "../images/cleaning_supplies/WhatsApp Image 2025-04-03 at 00.06.16.jpeg";

const ImageGallery: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const { t } = useLanguage();

  // Define all gallery images with translations
  const allImages = [
    // Baby Products
    { id: 1, url: baby1, alt: t("project.baby") },
    { id: 2, url: baby2, alt: t("project.baby") },
    { id: 3, url: baby3, alt: t("project.baby") },
    { id: 4, url: baby4, alt: t("project.baby") },
    { id: 5, url: baby5, alt: t("project.baby") },
    { id: 6, url: baby6, alt: t("project.baby") },

    // Bat Mitzvah
    { id: 7, url: batMitzva1, alt: t("project.batmitzvah") },
    { id: 8, url: batMitzva2, alt: t("project.batmitzvah") },
    { id: 9, url: batMitzva3, alt: t("project.batmitzvah") },

    // Chanukah
    { id: 10, url: chanukah1, alt: t("project.chanukah") },
    { id: 11, url: chanukah2, alt: t("project.chanukah") },
    { id: 12, url: chanukah3, alt: t("project.chanukah") },
    { id: 13, url: chanukah4, alt: t("project.chanukah") },
    { id: 14, url: chanukah5, alt: t("project.chanukah") },
    { id: 15, url: chanukah6, alt: t("project.chanukah") },
    { id: 16, url: chanukah7, alt: t("project.chanukah") },
    { id: 17, url: chanukah8, alt: t("project.chanukah") },
    { id: 18, url: chanukah9, alt: t("project.chanukah") },
    { id: 19, url: chanukah10, alt: t("project.chanukah") },
    { id: 20, url: chanukah11, alt: t("project.chanukah") },
    { id: 21, url: chanukah12, alt: t("project.chanukah") },
    { id: 22, url: chanukah13, alt: t("project.chanukah") },
    { id: 23, url: chanukah14, alt: t("project.chanukah") },
    { id: 24, url: chanukah15, alt: t("project.chanukah") },

    // School Supplies
    { id: 25, url: school1, alt: t("project.school") },
    { id: 26, url: school2, alt: t("project.school") },
    { id: 27, url: school3, alt: t("project.school") },
    { id: 28, url: school4, alt: t("project.school") },
    { id: 29, url: school5, alt: t("project.school") },
    { id: 30, url: school6, alt: t("project.school") },

    // Tu Bishvat
    { id: 31, url: tuBishvat1, alt: t("project.tubshvat") },
    { id: 32, url: tuBishvat2, alt: t("project.tubshvat") },
    { id: 33, url: tuBishvat3, alt: t("project.tubshvat") },

    // Cleaning Supplies
    { id: 34, url: cleaning1, alt: t("project.cleaning") },
    { id: 35, url: cleaning2, alt: t("project.cleaning") },
    { id: 36, url: cleaning3, alt: t("project.cleaning") },
    { id: 37, url: cleaning4, alt: t("project.cleaning") },
    { id: 38, url: cleaning5, alt: t("project.cleaning") },
    { id: 39, url: cleaning6, alt: t("project.cleaning") },
    { id: 40, url: cleaning7, alt: t("project.cleaning") },
    { id: 41, url: cleaning8, alt: t("project.cleaning") },
  ];

  // Get the number of images to display based on screen width
  const getImagesPerPage = useCallback(() => {
    if (window.innerWidth <= 480) {
      return 3; // Show 3 images on mobile phones (changed from 2)
    } else if (window.innerWidth <= 768) {
      return 3; // Show 3 images on tablets
    } else if (window.innerWidth <= 1024) {
      return 4; // Show 4 images on smaller desktops
    }
    return 6; // Show 6 images on large desktops
  }, []);

  const [imagesPerPage, setImagesPerPage] = useState(getImagesPerPage());

  // Update imagesPerPage when window is resized
  useEffect(() => {
    const handleResize = () => {
      setImagesPerPage(getImagesPerPage());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [getImagesPerPage]);

  const nextPage = () => {
    setCurrentPage(
      (prev) => (prev + 1) % Math.ceil(allImages.length / imagesPerPage)
    );
  };

  const previousPage = () => {
    setCurrentPage((prev) =>
      prev === 0 ? Math.ceil(allImages.length / imagesPerPage) - 1 : prev - 1
    );
  };

  // Get current page's images
  const getCurrentImages = () => {
    const start = currentPage * imagesPerPage;
    return allImages.slice(start, start + imagesPerPage);
  };

  return (
    <div className="gallery-container">
      <button
        className="gallery-arrow left"
        onClick={previousPage}
        aria-label="Previous page"
      >
        <ArrowBackIos />
      </button>

      <div className="gallery-images">
        {getCurrentImages().map((image) => (
          <div key={image.id} className="gallery-square">
            <img src={image.url} alt={image.alt} loading="lazy" />
          </div>
        ))}
      </div>

      <button
        className="gallery-arrow right"
        onClick={nextPage}
        aria-label="Next page"
      >
        <ArrowForwardIos />
      </button>
    </div>
  );
};

export default ImageGallery;
